import ShopifyObject from './ShopifyObject';

export default class Address extends ShopifyObject {
  /**
   * @param {ShopifyAddress} address
   */
  constructor(address) {
    super(address.id);

    this._customerId = address.customer_id || 0;
    this._firstName = address.first_name || '';
    this._lastName = address.last_name || '';
    this._company = address.company || '';
    this._address1 = address.address1 || '';
    this._address2 = address.address2 || '';
    this._city = address.city || '';
    this._province = address.province || '';
    this._country = address.country || '';
    this._zip = address.zip || '';
    this._phone = address.phone || '';
    this._name = address.name || '';
    this._provinceCode = address.province_code || '';
    this._countryCode = address.country_code || '';
    this._countryName = address.country_name || '';
    this._default = address.default || true;
  }

  /**
   * @returns {string}
   */
  get customerId() {
    return this._customerId;
  }

  /**
   * @returns {string}
   */
  get firstName() {
    return this._firstName;
  }

  /**
   * @param {string}
   */
  set firstName(firstName) {
    this._firstName = firstName;
  }

  /**
   * @returns {string}
   */
  get lastName() {
    return this._lastName;
  }

  /**
   * @param {string}
   */
  set lastName(lastName) {
    this._lastName = lastName;
  }

  /**
   * @returns {string}
   */
  get company() {
    return this._company;
  }

  /**
   * @param {string}
   */
  set company(company) {
    this._company = company;
  }

  /**
   * @returns {string}
   */
  get address1() {
    return this._address1;
  }

  /**
   * @param {string}
   */
  set address1(address1) {
    this._address1 = address1;
  }

  /**
   * @returns {string}
   */
  get address2() {
    return this._address2;
  }

  /**
   * @param {string}
   */
  set address2(address2) {
    this._address2 = address2;
  }

  /**
   * @returns {string}
   */
  get city() {
    return this._city;
  }

  /**
   * @param {string}
   */
  set city(city) {
    this._city = city;
  }

  /**
   * @returns {string}
   */
  get province() {
    return this._province;
  }

  /**
   * @param {string}
   */
  set province(province) {
    this._province = province;
  }

  /**
   * @returns {string}
   */
  get country() {
    return this._country;
  }

  /**
   * @param {string}
   */
  set country(country) {
    this._country = country;
  }

  /**
   * @returns {string}
   */
  get zip() {
    return this._zip;
  }

  /**
   * @param {string}
   */
  set zip(zip) {
    this._zip = zip;
  }

  /**
   * @returns {string}
   */
  get phone() {
    return this._phone;
  }

  /**
   * @param {string}
   */
  set phone(phone) {
    this._phone = phone;
  }

  /**
   * @returns {string}
   */
  get name() {
    return this._name;
  }

  /**
   * @param {string}
   */
  set name(name) {
    this._name = name;
  }

  /**
   * @returns {string}
   */
  get provinceCode() {
    return this._provinceCode;
  }

  /**
   * @param {string}
   */
  set provinceCode(provinceCode) {
    this._provinceCode = provinceCode;
  }

  /**
   * @returns {string}
   */
  get countryCode() {
    return this._countryCode;
  }

  /**
   * @param {string}
   */
  set countryCode(countryCode) {
    this._countryCode = countryCode;
  }

  /**
   * @returns {string}
   */
  get countryName() {
    return this._countryName;
  }

  /**
   * @param {string}
   */
  set countryName(countryName) {
    this._countryName = countryName;
  }

  /**
   * @returns {boolean}
   */
  get default() {
    return this._default;
  }

  /**
   * @param {string}
   */
  set default(defaultAddress) {
    this._default = defaultAddress;
  }

  /**
   *
   * @return {Object} - Shopify Address Object.
   */
  JSON() {
    return {
      id: super.id,
      customer_id: this.customerId,
      first_name: this.firstName,
      last_name: this.lastName,
      company: this.company,
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      province: this.province,
      country: this.country,
      zip: this.zip,
      phone: this.phone,
      name: this.name,
      province_code: this.provinceCode,
      country_code: this.countryCode,
      country_name: this.countryName,
      default: this.default,
    };
  }
}
